
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/62bfd8064e11f74310ce1cc00b80d48a/3da7f5a87525b7e8e674eef0499683ae.png" 
                alt="EGE 지구환경전문가그룹" 
                className="h-12 w-auto"
                title="EGE 지구환경전문가그룹"
              />
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              건설 현장의 안전과 효율성을 위한 통합자동화 계측 솔루션을 제공합니다. 
              첨단 IoT 기술과 AI 분석으로 건설 프로젝트의 성공을 보장합니다.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">서비스</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">구조물 계측</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">지반 모니터링</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">환경 계측</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">안전 관리</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">데이터 분석</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">연락처</h4>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-blue-400"></i>
                <span className="text-gray-300">031-5177-5100</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line text-blue-400"></i>
                <span className="text-gray-300">cagito@ege.co.kr</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-map-pin-line text-blue-400"></i>
                <span className="text-gray-300">경기도 의왕시 성고개로 53, 1020호</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 EGE. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">개인정보처리방침</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">이용약관</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
